import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const RoundButton = styled(Button)({
  borderRadius: "50vh",
});
